import React,{Component} from "react";
import { withRouter } from 'react-router';
// import Wrp from '../../hoc/Wrp/Wrp';
import { connect } from 'react-redux';
import * as actions from '../../../store/actions';
import CertificateList from "./CertificateList";

class DomainCertificate extends Component{
    render(){      
        return <CertificateList  {...this.props} />          
    }
}
  
const mapDispatchToProps = dispatch => {
    return {
      Loader : () => dispatch(actions.loader()),
      succMessage : (msg) => dispatch(actions.succMessage(msg)),
      failMessage : (msg) => dispatch(actions.failMessage(msg))      
    };
}
export default
    connect(
      null, 
      mapDispatchToProps
    )(withRouter(DomainCertificate));